if (!customElements.get('product-listing')) {  
  class ProductListing extends HTMLElement {
    constructor() {
      super();
      this.id = this.dataset.id;
      this.sortBy = 'relevency';
      this.page = 1;
      this.narrowBy = [];
    }
    
    connectedCallback() {
      this.initFastSimonSDK();
      this.loadPage();
      this.setupModalOpenListener();
      this.setupProductClickListener();
      this.setupApplyFilterListener();
      this.setupActionButtonListener();
    }
    
    initFastSimonSDK() {
      poll(() => window.FastSimonSDK, 10000, 150)
      .then(() => {
        this.syncFiltersFromUrl();
        this.klaviyoID = __isp_get_customer_identifier_from_klaviyo();
      })
      .catch((err) => {
        console.error('Fast Simon took too long to load.', err);
      });
    }
    
    setupModalOpenListener() {
      window.addEventListener('modal-open:filter', () => {
        setTimeout(() => {
          this.loadFilters();
          this.populateRemoveFilterButtons();
          this.populateSortBy();
        }, 10);
      });
    }
    
    setupProductClickListener() {
      this.addEventListener('click', (e) => {
        const anchor = e.target.closest('[data-product-url][data-product-id][href]');
        if (!anchor) return;
        
        e.preventDefault();
        const index = [...this.querySelectorAll('[data-product-url][data-product-id][href]')]
        .findIndex(({ href }) => href === anchor.href);
        
        this.trackProductClick(anchor, index);
        window.location.href = anchor.href;
      });
    }
    
    trackProductClick(anchor, index) {
      const eventData = {
        kl_id: this.klaviyoID,
        productID: anchor.dataset.productId,
        position: index + 1
      };
      
      if (this.id === 'search') {
        const searchParams = new URLSearchParams(window.location.search);
        const term = searchParams.get('q');
        eventData.query = term;
        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.SerpProductClicked,
          data: eventData
        });
      } else {
        eventData.collectionID = this.id;
        eventData.query = undefined; // Default = Collection_Name
        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.CollectionProductClicked,
          data: eventData
        });
      }
    }
    
    setupApplyFilterListener() {
      document.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action="apply-filter"]');
        if (clickedElement) {
          const productsWrap = this.querySelector('[data-products-wrap]');
          const appliedFiltersWrap = document.querySelectorAll('[data-applied-filters-wrap]');
          const newURL = new URL(window.location);
          this.handleApplyFilter(clickedElement, productsWrap, appliedFiltersWrap, newURL);
        }
      });
    }
    
    setupActionButtonListener() {
      document.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const productsWrap = this.querySelector('[data-products-wrap]');
        const appliedFiltersWrap = document.querySelectorAll('[data-applied-filters-wrap]');
        const newURL = new URL(window.location);
        let action = clickedElement?.dataset.action;
        let filterValue = clickedElement?.dataset.filterValue;
        
        switch (action) {
          case 'apply-filter':
            this.handleApplyFilter(clickedElement, productsWrap, appliedFiltersWrap, newURL);
          break;
          case 'clear-filters':
            document.querySelectorAll(`[data-action="apply-filter"]`)
              .forEach(el => el.removeAttribute('checked'));
            this.handleRemoveAllFilters(appliedFiltersWrap, newURL);
          break
          case 'remove-filter':
            document.querySelectorAll(`[data-action="apply-filter"][value="${filterValue}"]`)
              .forEach(el => el.removeAttribute('checked'));
            this.handleRemoveFilter(filterValue, appliedFiltersWrap, newURL);
          break;
          case 'load-more':
            this.handleLoadMore(newURL);
          break;
          default:
          break;
        }
      });
      
      document.addEventListener('change', (e) => {
        const changedElement = e.target.closest('[data-action]');
        if (!changedElement) return;
        
        const productsWrap = this.querySelector('[data-products-wrap]');
        const appliedFiltersWrap = document.querySelectorAll('[data-applied-filters-wrap]');
        const newURL = new URL(window.location);
        let action = changedElement?.dataset.action;
        
        switch (action) {
          case 'sort':
            this.handleSort(changedElement, productsWrap, newURL);
          break;
          case 'apply-special-filter':
            this.handleApplySelectFilter(changedElement, productsWrap, newURL);
          break;
          default:
          break;
        }
      });
    }
    
    createFilterDropdowns(filters = this.filters) {
      if (!filters) return;
            
      const filterContainer = this.querySelector('[data-special-filters]');
      filterContainer.innerHTML = '';  
      
      filters.forEach(([filterKey, filterValues, filterName], i) => {
        if (filterName === 'Size' || filterName === 'Shoe size') {
          const hasGenderAndSize = hasGenderAndSizeFilters(filters) && !window.location.search.includes(`Isp-tag-Gender`);
          const hasKids = hasKidsFilter(filters) && !window.location.search.includes(`Isp-tag-Gender`); //USE THIS

          const temp = document.createElement('div');
          temp.insertAdjacentHTML('beforeend', 
            hasGenderAndSize ?
            renderGenderedSizeSelector({ allFilters: filters, id: `special-filter-${filterKey.replaceAll(' ', '-')}`, values: filterValues, name: `${filterKey}-sidebar` })
            :
            renderSizeSelector({ values: filterValues, id: `special-filter-${filterKey}`, name: filterKey, hasKids })
            
          );

          filterContainer.insertAdjacentHTML(`beforeend`, `
            <custom-dropdown id="special-filter-dropdown-${filterKey.replaceAll(' ', '-')}" class="relative [&.active_.icon]:rotate-180 [&:not(.active)_[data-content]]:hidden">
              <button data-toggle class="flex items-center pb-1.5 pr-[9px] gap-3">
                <span class="text-sm leading-none">Size</span>
                <span class="icon block w-[14px] h-[14px] transition">
                  <svg width="100%" height="100%" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector 714 (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M1.80004 3.52118L6.00004 7.72118L10.2 3.52118L10.8789 4.2L6.00004 9.07882L1.12122 4.2L1.80004 3.52118Z" />
                  </svg>
                </span>
              </button>
              <div data-content class="max-w-[328px] gap-3 flex flex-wrap ">
                ${temp.innerHTML}
              </div
            </custom-dropdown>
          `);
        } else if(filterName === 'Type' || filterName === 'Product Type' || filterName === 'Style') {
          const temp = document.createElement('div');
          temp.insertAdjacentHTML('beforeend', 
            renderTypeSelector({ values: filterValues, id: `special-filter-${filterKey}`, name: filterKey })
          );
          
          filterContainer.insertAdjacentHTML(`beforeend`, `
            <custom-dropdown id="special-filter-dropdown-${filterKey.replaceAll(' ', '-')}" data-select-wrap class="relative [&.active_.icon]:rotate-180 [&:not(.active)_[data-content]]:hidden">
              <button data-toggle class="flex items-center pb-1.5 pr-[9px] gap-3">
                <span class="text-sm leading-none">Style</span>
                <span class="icon block w-[14px] h-[14px] transition">
                  <svg width="100%" height="100%" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector 714 (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M1.80004 3.52118L6.00004 7.72118L10.2 3.52118L10.8789 4.2L6.00004 9.07882L1.12122 4.2L1.80004 3.52118Z" />
                  </svg>
                </span>
              </button>
              <div data-content class="grid grid-cols-2 gap-2 ">
                ${temp.innerHTML}
              </div
            </custom-dropdown>
          `);

        } else if (filterName === 'Color') {
          const temp = document.createElement('div');
          
          const colorTagsToRender = [];
          for (let i = 0; i < colors.length; i++) {
            const colorArr = colors[i].split(':');
            const title = colorArr[0];
            const value = colorArr[1];
            const filterToRender = filterValues?.find((filterValueArr) => filterValueArr[0] === value);
            if (!filterToRender) continue;
            colorTagsToRender.push({ title, value, swatch: colorsSwatches[title], count: filterToRender[1] });        
          }
          
          if (colorTagsToRender.length) {
            temp.insertAdjacentHTML('beforeend', 
              renderTagSelector({ values: colorTagsToRender, id: `special-filter-${filterKey}`, name: filterKey, label: 'Color' })
            );
          }
          
          filterContainer.insertAdjacentHTML(`beforeend`, `
            <custom-dropdown id="special-filter-dropdown-${filterKey.replaceAll(' ', '-')}" data-select-wrap class="relative [&.active_.icon]:rotate-180 [&:not(.active)_[data-content]]:hidden">
              <button data-toggle class="flex items-center pb-1.5 pr-[9px] gap-3">
                <span class="text-sm leading-none">Color</span>
                <span class="icon block w-[14px] h-[14px] transition">
                  <svg width="100%" height="100%" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector 714 (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M1.80004 3.52118L6.00004 7.72118L10.2 3.52118L10.8789 4.2L6.00004 9.07882L1.12122 4.2L1.80004 3.52118Z" />
                  </svg>
                </span>
              </button>
              <div data-content class="grid grid-cols-2 gap-2 ">
                ${temp.innerHTML}
              </div
            </custom-dropdown>
          `);
        }
      });
    }    
    
    handleSort(clickedElement, productsWrap, newURL) {
      if (this.sortBy === clickedElement.value || clickedElement.value === 'Sort By') return;
      productsWrap.innerHTML = '';
      this.sortBy = clickedElement.value;
      newURL.searchParams.set('sortBy', clickedElement.value);
      window.history.replaceState({}, 'Sort applied', newURL.toString());
      this.loadPage();
    }
    
    handleApplySelectFilter(changedElement, productsWrap, newURL) {
      productsWrap.innerHTML = '';
      this.classList.remove('fully-loaded');
      this.page = 1;
            
      if (changedElement?.dataset.action === 'apply-special-filter') {
        const filterValue = changedElement.value;
        const filterName = changedElement.name;
        
        if (!filterValue) {
          newURL.searchParams.delete(filterName);
          window.history.replaceState({}, 'Filters applied', newURL.toString());
          this.syncSpecialFilters(newURL);
          this.loadPage();
          return;
        }
        
        this.narrowBy = [];
        [...newURL.searchParams.keys()].forEach((key) => {
          if (key === filterName) {
            newURL.searchParams.delete(key);
          }
        });
        if (filterValue) newURL.searchParams.append(filterName, filterValue);
        this.narrowBy.push([filterName, filterValue]);
      }
      
      window.history.replaceState({}, 'Filters applied', newURL.toString());
      
      this.syncSpecialFilters(newURL);
      this.loadPage();
    }
    
    handleApplyFilter(clickedElement, productsWrap, appliedFiltersWrap, newURL) {
      productsWrap.innerHTML = '';
      
      this.classList.remove('fully-loaded');
      this.page = 1;
      this.narrowBy = [];
      
      if (clickedElement?.dataset.genderToggle) {
        const filterValue = clickedElement.value;
        const filterName = clickedElement.name;    
        [...newURL.searchParams.keys()].forEach((key) => {
          if (key === filterName) {
            newURL.searchParams.delete(key);
          }
        });
        if (clickedElement.classList.contains('active')) {
          if (!newURL.searchParams.has(filterName) || !newURL.searchParams.getAll(filterName).includes(filterValue)) {
            newURL.searchParams.append(filterName, filterValue);
          }
        } else {
          const currentFilterValues = newURL.searchParams.getAll(filterName);
          if (currentFilterValues.includes(filterValue)) {
            newURL.searchParams.delete(filterName, filterValue);
          }
        }    
        const otherToggles = document.querySelectorAll(`[data-gender-toggle][name="${filterName}"]`);
        otherToggles.forEach((toggle) => {
          if (toggle !== clickedElement && toggle.classList.contains('active')) {
            toggle.classList.remove('active');
          }
        });
      }
      
      if (clickedElement?.dataset.action === 'apply-filter' && !clickedElement?.dataset.genderToggle) {
        const filterValue = clickedElement.value;
        const filterName = clickedElement.name;
        const currentFilterValues = newURL.searchParams.getAll(filterName);
        
        if (clickedElement.checked) {
          if (!currentFilterValues.includes(filterValue)) {
            newURL.searchParams.append(filterName, filterValue);
          }
        } else {
          if (currentFilterValues.includes(filterValue)) {
            newURL.searchParams.delete(filterName, filterValue);
          }
        }
      }
      
      if (clickedElement?.dataset.gender) {
        const genderFilterName = 'Isp-tag-Gender';
        const genderFilterValue = `${clickedElement.dataset.gender}`;
        if (!newURL.searchParams.has(genderFilterName) || !newURL.searchParams.getAll(genderFilterName).includes(genderFilterValue)) {
          newURL.searchParams.append(genderFilterName, genderFilterValue);
        }
      }
      
      window.history.replaceState({}, 'Filters applied', newURL.toString());
      [...newURL.searchParams.entries()].forEach(([filterName, filterValue]) => {
        this.narrowBy.push([filterName, filterValue]);
      });
      
      this.syncSpecialFilters(newURL);
      this.loadPage();
    }  
    
    handleRemoveFilter(filterValue, appliedFiltersWrap, newURL) {
      if (appliedFiltersWrap) appliedFiltersWrap.forEach(el => el.innerHTML = '');
      this.narrowBy = [];
    
      [...newURL.searchParams.keys()].forEach(key => {
        const values = newURL.searchParams.getAll(key);
        if (values.includes(filterValue)) {
          newURL.searchParams.delete(key, filterValue);
          window.history.replaceState({}, 'Filters removed', newURL.toString());
        }
      });
    
      // Reset matching filter dropdowns
      const matchingSelects = this.querySelectorAll(`[data-action="apply-special-filter"][name]`);
      matchingSelects.forEach(selectElement => {
        const selectName = selectElement.name;
        const currentFilterValues = new URLSearchParams(window.location.search).getAll(selectName);
    
        // If the value to be removed exists in the URL, reset the selected value
        if (!currentFilterValues.includes(filterValue)) {
          selectElement.selectedIndex = 0; // Reset to the default option
        }
      });
    
      if (filterValue) {
        const genderToggles = document.querySelectorAll(`[data-gender-toggle][value="${filterValue}"]`);
        genderToggles.forEach(toggle => {
          toggle.classList.remove('active');
        });
      }
    
      [...newURL.searchParams.keys()].forEach(key => {
        const values = newURL.searchParams.getAll(key);
        values.forEach(value => {
          const filterInput = this.querySelector(`input[name="${key}"][value="${value}"]`);
          if (filterInput) {
            filterInput.checked = true;
          }
          this.narrowBy.push([key, value]);
        });
      });
    
      this.syncSpecialFilters(newURL);
      this.page = 1;
      this.loadPage();
    }
    
    handleRemoveAllFilters(appliedFiltersWrap, newURL) {
      if (appliedFiltersWrap) appliedFiltersWrap.forEach(el => el.innerHTML = '');
      this.narrowBy = [];
    
      // List of known UTM and other non-filter params to preserve
      const preservedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'sortBy', 'q'];
      const preserved = new URLSearchParams();
    
      // Preserve non-filter parameters
      newURL.searchParams.forEach((value, key) => {
        if (preservedParams.includes(key)) {
          preserved.append(key, value);
        }
      });
    
      // Replace URL with only preserved params
      newURL.search = preserved.toString();
      window.history.replaceState({}, 'Filters removed', newURL.toString());
    
      // Reset filter dropdowns
      const matchingSelects = this.querySelectorAll(`[data-action="apply-special-filter"][name]`);
      matchingSelects.forEach(select => {
        select.selectedIndex = 0;
      });
    
      // Remove active state from all gender toggles
      const genderToggles = document.querySelectorAll(`[data-gender-toggle].active`);
      genderToggles.forEach(toggle => {
        toggle.classList.remove('active');
      });
    
      // Uncheck all filter checkboxes
      const allInputs = this.querySelectorAll('input[type="checkbox"][name]');
      allInputs.forEach(input => {
        input.checked = false;
      });
    
      this.syncSpecialFilters(newURL);
      this.page = 1;
      this.loadPage();
    }    
    
    syncSpecialFilters(newURL) {
      [...newURL.searchParams.entries()].forEach(([filterName, filterValue]) => {
        if (filterName.includes('Isp-tag-Gender') && filterValue) {
          const genderToggles = document.querySelectorAll(`[data-gender-toggle]`);
          const urlFilterValues = newURL.searchParams.getAll(filterName);
    
          if (urlFilterValues.length > 1) {
            genderToggles.forEach(toggle => toggle.classList.remove('active'));
          }
              
          const matchingToggles = [...genderToggles].filter(toggle => toggle.value === urlFilterValues[0]);
          if (matchingToggles.length) {
            matchingToggles.forEach(
              matchingToggle => matchingToggle.classList.add('active')
            )
          }
        }
      });
    
      const matchingSelects = this.querySelectorAll(`[data-action="apply-special-filter"][name]`);
      matchingSelects.forEach(selectElement => {
        let selectName = selectElement.name;
        const currentFilterValues = new URLSearchParams(newURL.search).getAll(selectName);
        if (currentFilterValues.length > 1 && selectElement.closest('span')) {
          selectElement.closest('span').style.display = 'none';
        } else if (selectElement.closest('span')) {
          selectElement.closest('span').style.display = null;
          const selectedValue = currentFilterValues[0];
          const option = [...selectElement.options].find(opt => opt.value === selectedValue);
          if (option) {
            selectElement.value = selectedValue;
          }
        }
      });
    }    
    
    handleLoadMore(newURL) {
      const scrollY = window.scrollY;
      this.page += 1;
      newURL.searchParams.set('page', this.page);
      window.history.replaceState({}, 'Pagination applied', newURL.toString());
      this.loadPage().then(() => window.scrollTo(0, scrollY));
    }
    
    syncFiltersFromUrl() {
      const newURL = new URL(window.location);
      const sortBy = newURL.searchParams.get('sortBy');
      for (const key of newURL.searchParams.keys()) {
        const values = newURL.searchParams.getAll(key);
        values.map((value) => {
          const filterInput = this.querySelector(`input[name="${key}"][value="${value}"]`);
          if (filterInput) {
            this.narrowBy.push([key, value]);
            filterInput.checked = true;
          }
        });
      }
            
      if (sortBy) {
        this.sortBy = sortBy;
        this.populateSortBy();
      }
      
      this.syncSpecialFilters(newURL);
      
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent('apply-filter'));
      }, 100);
    }
    
    renderFilters(filters) {
      const filterWrap = document.createElement('div');
      const hasGenderAndSize = hasGenderAndSizeFilters(filters) && !window.location.search.includes(`Isp-tag-Gender`);
      const hasKids = hasKidsFilter(filters) && !window.location.search.includes(`Isp-tag-Gender`); //USE THIS
      
      filters.forEach((filter, i) => {
        const filterID = filter[2];
        switch (filter[2]) {
          case 'Price':
          
          break;
          case 'Price_min':
          // handled in price
          break;
          case 'Price_max':
          // handled in price
          break;
          case 'Shoe size':
            if (hasGenderAndSize) {
              filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
                label: filter[2], 
                id: filterID, 
                index: i,
                renderSelector: () => renderGenderedSizeSelector({ allFilters: filters, values: filter[1], id: `sidebar-${filterID.replaceAll(' ', '-')}`, name: filter[0] })
              }));
              break;
            }
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterID, 
              index: i,
              renderSelector: () => renderSizeSelector({ values: filter[1], id: filterID, name: filter[0], hasKids })
            }));
          break;
          case 'Size':
            if (hasGenderAndSize) {
              filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
                label: filter[2], 
                id: filterID, 
                index: i,
                renderSelector: () => renderGenderedSizeSelector({ allFilters: filters, values: filter[1], id: filterID, name: filter[0] })
              }));
              break;
            }
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterID, 
              index: i,
              renderSelector: () => renderSizeSelector({ values: filter[1], id: filterID, name: filter[0], hasKids })
            }));
          break;
          case 'Color':
            const colorTagsToRender = [];
            for (let i = 0; i < colors.length; i++) {
              const colorArr = colors[i].split(':');
              const title = colorArr[0];
              const value = colorArr[1];
              const filterToRender = filter[1]?.find((filterValueArr) => filterValueArr[0] === value);
              if (!filterToRender) continue;
              colorTagsToRender.push({ title, value, swatch: colorsSwatches[title], count: filterToRender[1] });        
            }
            
            if (colorTagsToRender.length) {
              filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
                label: 'Color', 
                id: filterID, 
                index: i,
                renderSelector: () => renderTagSelector({ values: colorTagsToRender, id: filterID, name: filter[0], label: 'Color' })
              }));
            }
          break;
          case 'Gender':
          // const genderTagsToRender = [];
          // for (let i = 0; i < genders.length; i++) {
          //   const genderArr = genders[i].split(':');
          //   const title = genderArr[0];
          //   const value = genderArr[1];
          //   const filterToRender = filter[1]?.find((filterValueArr) => filterValueArr[0] === value);
          //   if (!filterToRender) continue;
          //   genderTagsToRender.push({ title, value, count: filterToRender[1] });     
          // }
          
          // this.hasGenderToggle = ['gender-women', 'gender-men', 'gender-kids'].every(gender =>
          //   genderTagsToRender.some(x => x.value === gender)
          // );            
          
          // this.classList.toggle('has-gender-toggle', this.hasGenderToggle);
          
          // if (genderTagsToRender.length) {
          //   filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
          //     label: 'Gender', 
          //     id: filterID, 
          //     index: i,
          //     renderSelector: () => renderTagSelector({ values: genderTagsToRender, id: filterID, name: filter[0], label: 'Gender' })
          //   }));
          // }
          break;
          case 'Product Type':
          filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
            label: filter[2], 
            id: filterID, 
            index: i,
            renderSelector: () => renderTypeSelector({ values: filter[1], id: filterID, name: filter[0] })
          }));
          break;
          case 'Style':
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterID, 
              index: i,
              renderSelector: () => renderTypeSelector({ values: filter[1], id: filterID, name: filter[0] })
            }));
          break;
          case 'Type':
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterID, 
              index: i,
              renderSelector: () => renderTypeSelector({ values: filter[1], id: filterID, name: filter[0] })
            }));
          break;
          case 'Categories':
          filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
            label: filter[2], 
            id: filterID, 
            index: i,
            renderSelector: () => renderCategorySelector({ values: filter[1], id: filterID, name: filter[0] })
          }));
          break;
          default:
          filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
            label: filter[2], 
            id: filterID, 
            index: i,
            renderSelector: () => renderStandardSelector({ values: filter[1], id: filterID, name: filter[0] })
          }));
          break;
        }
      });
      
      return filterWrap;
    }
    
    loadFilters(filters = this.filters) {
      if (!filters) return;
      const filterWrap = document.querySelector('[data-filters-wrap]');
      if (!filterWrap) return;
      
      if (this.filtersLoaded) {
        const newHtml = this.renderFilters(filters);
        if (filterWrap.innerHTML.toString() === newHtml.toString()) return;
        
        const appliedFilters = [...new Set([...this.querySelectorAll('input[data-action="apply-filter"]:checked')])]
        .map((input) => ({ name: input.name, value: input.value }));
        
        appliedFilters.forEach(({ name, value }) => {
          newHtml.querySelectorAll(`input[data-action="apply-filter"][name="${name}"][value="${value}"]`)
          .forEach((input) => {
            input.setAttribute('checked', true);
          });
        });
        
        newHtml.querySelectorAll('.duration-500')
        .forEach((el) => el.classList.replace('duration-500', 'duration-0'));
        filterWrap.querySelectorAll(':scope > div > *:not([data-label="Price"])').forEach((el) => el.remove());
        newHtml.querySelectorAll(':scope > div > [data-label="Price"]').forEach((el) => el.remove());
        
        filterWrap.insertAdjacentHTML('beforeend', newHtml.innerHTML);
        
        [...this.querySelectorAll('[data-accordion-toggle]:not([data-label="Price"]):not([data-label="Size"]):not([data-label="Color"])')]
        .find((button) => {
          if (button.nextElementSibling.querySelectorAll('input[data-action="apply-filter"]:checked').length > 0) button.click();
        });
        this.querySelector('[data-label="Size"]')?.click()
        this.querySelector('[data-label="Color"]')?.click()
        
        filterWrap.querySelectorAll('.duration-0')
        .forEach((el) => el.classList.replace('duration-0', 'duration-500'));
        
        window.dispatchEvent(new CustomEvent('filters-rendered'));
        
        return;
      }
      
      if (filterWrap) filterWrap.innerHTML = this.renderFilters(filters)?.innerHTML;
      
      if (!this.filtersLoaded) {
        const sizeButton = this.querySelector('[data-label=Size]');
        const colorButton = this.querySelector('[data-label=Color]');
        sizeButton?.click();
        colorButton?.click();
      }
      
      this.filtersLoaded = true;
      this.syncFiltersFromUrl();
      window.dispatchEvent(new Event('FastSimon:plp-update', { bubbles: true }));
    }
    
    populateRemoveFilterButtons() {
      if (!this.filters?.length) return;
      
      const newURL = new URL(window.location);
      const appliedFiltersWrap = document.querySelectorAll('[data-applied-filters-wrap]');
      appliedFiltersWrap.forEach(el => el.innerHTML = '');
      const renderedFilters = new Set();
    
      const validFilters = new Set();
      this.filters.forEach(filter => {
        filter[1].forEach(option => validFilters.add(`${filter[0]}:${option[0]}`));
      });
    
      let appliedFiltersCount = 0;
      for (const key of newURL.searchParams.keys()) {
        const values = newURL.searchParams.getAll(key);
        for (const value of values) {
          const filterKey = `${key}:${value}`;
          if (validFilters.has(filterKey) && !renderedFilters.has(filterKey)) {
            appliedFiltersCount ++;
            appliedFiltersWrap.forEach(el =>
              el.insertAdjacentHTML('beforeend', renderRemoveSpecificFilterButton({ value, label: key, name: key }))
            );
            renderedFilters.add(filterKey);
          }
        }
      }
      
      document.querySelectorAll('[data-facet-count]')
        .forEach(el => el.innerText = appliedFiltersCount ? `(${appliedFiltersCount} Applied)` : '');
    }
    
    populateSortBy() {
      const sortBy = document.querySelectorAll('select[name="sort_by"]');
      if (sortBy && window.FastSimonSortBy) {
        const titleLookup = {
          PriceLowToHigh: 'Price Low to High',
          PriceHighToLow: 'Price High to Low',
          NewFirst: 'Newest',
          OldFirst: 'Oldest',
          AtoZ: 'A to Z',
          ZtoA: 'Z to A',
          relevancy: 'Recommended'
        };
                
        sortBy.forEach(el => el.innerHTML = `<option ${this.sortBy ? '' : 'selected'} disabled>Sort By</option>`);
        sortBy.forEach(el => el.insertAdjacentHTML('beforeend', Object.keys(window.FastSimonSortBy)
        .map((key) => `
            <option 
              ${window.FastSimonSortBy[key] === this.sortBy ? 'selected' : ''} 
              value="${window.FastSimonSortBy[key]}"
            >
              ${titleLookup[key] || key}
            </option>
          `)));
      } else if (sortBy && !window.FastSimonSortBy) {
        sortBy.forEach(el => el.closest('[data-sort-wrap]')?.classList.add('hidden'));
      }
    }
    
    renderResults(response) {
      const productsWrap = this.querySelector('[data-products-wrap]');
      const promoTemplate = document.querySelector('[data-promo-tile]');
      const promoPos = Number(promoTemplate?.dataset.promoTile);
      const collectionInfo = this.querySelector('[data-collection-info]');
      
      productsWrap.querySelector('[data-loading-skeleton]')?.remove();
            
      if ((this.page >= response.payload.pageCount) || !response.payload.totalResults) {
        this.classList.add('fully-loaded');
      } else {
        this.classList.remove('fully-loaded');
      }
      
      if (!response.payload.totalResults) {
        this.classList.add('no-results');
        this.populateRemoveFilterButtons();
        return;
      } else {
        this.classList.remove('no-results');
      }
      
      if (this.page === response.payload.pageCount) {
        collectionInfo.innerText = `Showing ${response.payload.totalResults} of ${response.payload.totalResults} products`;
      } else {
        const productsPerPage = response.payload.products.length;
        collectionInfo.innerText = `Showing ${productsPerPage * this.page} of ${response.payload.totalResults} products`;
      }
      
      
      document.querySelectorAll('[data-results-wrap]').forEach((el) => {
        el.innerText = response.payload.totalResults; 
      });
      
      // Handle results inside templates for unopened filter drawer
      document.querySelectorAll('template').forEach((template) => {
        const elementsInTemplate = template.content.querySelectorAll('[data-results-wrap]');
        elementsInTemplate.forEach((el) => {
          el.innerText = response.payload.totalResults;
        });
      });
      
    if (this.page === 1) productsWrap.innerHTML = '';
      for (let i = 0; i < response.payload.products.length; i++) {
        const product = response.payload.products[i];
        if (productsWrap.querySelector(`[href="${product.u}"]`) || productsWrap.querySelector(`[data-url="${product.u}"]`)) return;
        
        productsWrap.insertAdjacentHTML('beforeend', `
          ${((promoPos - 1) === i) ? promoTemplate.cloneNode(true).innerHTML : ''}
          <intersection-loader 
            data-url="${product.u}" 
            data-section-id="product-tile"
          >${plpLoader}</intersection-loader>
        `);
      };
        
      const productResponse = response.payload.products
      const productList = []
      const list = localStorage.getItem("___ELEVAR_GTM_SUITE--lastCollectionPathname");
      const cat = list?.replace('/collections/', '' )?.replace('-', ' ').toUpperCase();
      
      productResponse.forEach((product, index) => {
        let variantName = product.l.split(' - ');
        let variantID = product.s.split('::');
        let item = {
          id: product.sku,
          name: product.l,
          brand: product.v,
          category: cat,
          variant: variantName[1],
          list: list,
          product_id: product.id,
          variant_id: variantID[1],
          price: product.p,
          compare_at_price: product.p_c,
          position: index+1
        };
        productList.push(item)
      });
    }
    
    hasMen(data = this.filters) {
      if (!data) return;  
      const genderEntry = data.find(entry => entry[0] === "Isp-tag-Gender");
      if (!genderEntry) return false;
      
      const genderValues = genderEntry[1].map(item => item[0]);
      return genderValues.includes("gender-men");
    }
      
    hasWomen(data = this.filters) {
      if (!data) return;  
      
      if (!data) return;  
      const genderEntry = data.find(entry => entry[0] === "Isp-tag-Gender");
      if (!genderEntry) return false;
      
      const genderValues = genderEntry[1].map(item => item[0]);
      return genderValues.includes("gender-women");
    }
    
    hasMenAndWomen(data = this.filters) {
      if (!data) return;
      const genderEntry = data.find(entry => entry[0] === "Isp-tag-Gender");
      if (!genderEntry) return false;
      
      const genderValues = genderEntry[1].map(item => item[0]);
      return genderValues.includes("gender-men") && genderValues.includes("gender-women");
    }
    

    hasKids(data = this.filters) {
      if (!data) return;
      const genderEntry = data.find(entry => entry[0] === "Isp-tag-Gender");
      if (!genderEntry) return false;
      
      const genderValues = genderEntry[1].map(item => item[0]);
      return genderValues.includes("gender-kids")
    }

    async loadPage() {
      this.classList.add('loading-products');
      const promoTemplate = document.querySelector('[data-promo-tile]');
      const promoSize = promoTemplate ? parseInt(promoTemplate.dataset.width) || 0 : 0;
      const productsPerPage = 24 - promoSize; // Offset by promoSize
    
      return new Promise((resolve, reject) => {
        if (this.id === "search") {
          const searchParams = new URLSearchParams(window.location.search);
          const term = searchParams.get('q');
          
          window.FastSimonSDK.fullTextSearch({
            term: term,
            page: this.page,
            productsPerPage: productsPerPage, 
            narrowBy: this.narrowBy,
            sortBy: this.sortBy,
            callback: (response) => {
              this.renderResults(response);
              this.loadFilters(response.payload.facets);
              this.filters = response.payload.facets;
              if (this.filters) {
                this.classList.toggle(`gender-filters`, this.hasMenAndWomen(response.payload.facets) || false);
                this.classList.toggle(`gender-filters-kids`, this.hasKids(response.payload.facets) || false);
                this.classList.toggle(`gender-filters-women`, this.hasWomen(response.payload.facets));
                this.classList.toggle(`gender-filters-men`, this.hasMen(response.payload.facets));
                this.createFilterDropdowns(response.payload.facets);
              }
              this.populateRemoveFilterButtons();
              this.populateSortBy();
              
              window.FastSimonSDK.event({
                eventName: window.FastSimonEventName.SearchPerformed,
                data: {
                  kl_id: this.klaviyoID,
                  query: term,
                  narrowBy: this.narrowBy,
                  sortBy: this.sortBy,
                  products: response.payload.products.map(({ id }) => id).toString(),
                  rescount: response.payload.totalResults,
                  pagenum: Math.ceil(response.payload.totalResults / productsPerPage) 
                }
              });
              
              this.classList.remove('loading-products');
              resolve(); // Resolve the promise when done
            },
            error: (err) => {
              this.classList.remove('loading-products');
              reject(err); // Reject the promise on error
            }
          });
        } else {
          const isTurbo = sessionStorage.getItem('isTurbo') === 'true' ? true : false;
          sessionStorage.setItem('isTurbo', false); 
          window.FastSimonSDK.smartCollections({
            categoryID: this.id,
            page: this.page,
            narrowBy: this.narrowBy,
            sortBy: this.sortBy,
            productsPerPage: productsPerPage, 
            callback: (response) => {
              this.renderResults(response);
              this.loadFilters(response.payload.facets);
              this.filters = response.payload.facets;
              if (this.filters) {
                this.classList.toggle(`gender-filters`, this.hasMenAndWomen(response.payload.facets) || false);
                this.classList.toggle(`gender-filters-kids`, this.hasKids(response.payload.facets) || false);
                this.classList.toggle(`gender-filters-women`, this.hasWomen(response.payload.facets));
                this.classList.toggle(`gender-filters-men`, this.hasMen(response.payload.facets));
                this.createFilterDropdowns(response.payload.facets);
              }
              this.populateRemoveFilterButtons();
              this.populateSortBy();
              window.FastSimonSDK.event({
                eventName: window.FastSimonEventName.SmartCollectionPreformed,
                data: {
                  kl_id: this.klaviyoID,
                  categoryID: this.id,
                  narrowBy: this.narrowBy,
                  sortBy: this.sortBy,
                  products: response.payload.products.map(({ id }) => id).toString(),
                  rescount: response.payload.totalResults,
                  pagenum: Math.ceil(response.payload.totalResults / productsPerPage), 
                  fromTurboLink: isTurbo
                }
              });
              
              this.classList.remove('loading-products');
              resolve(); // Resolve the promise when done
            },
            error: (err) => {
              this.classList.remove('loading-products');
              reject(err); // Reject the promise on error
            }
          });
        }
      });
    }
  }
    
  customElements.define('product-listing', ProductListing);
}
  
  
  // plp utilities
  const plpLoader = `
    <div class="block bg-pampas rounded-xl aspect-[0.73/1] z-0 relative">
      <div class="loader flex items-center justify-center">
        <span class="block w-12 h-12">
          <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </span>
      </div>
    </div>
  `;
  
  const accordionIcon = `
    <svg width="100%" height="100%" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L9 9L1 17" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;
  
  const checkmarkIcon = `
    <svg width="15" height="12" viewBox="0 0 15 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="-ml-[1px]">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9625 0.325864C14.5059 0.80333 14.5594 1.63092 14.0819 2.17434L5.44878 12L0.444691 7.59791C-0.0984409 7.12012 -0.151409 6.2925 0.326384 5.74936C0.804177 5.20623 1.6318 5.15326 2.17493 5.63106L5.21098 8.30186L12.114 0.445283C12.5915 -0.0981361 13.4191 -0.151602 13.9625 0.325864Z"/>
    </svg>
  `;
  
  const xIcon = `
    <svg width="100%" height="100%" stroke="currentColor" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.00001 17L9 9.00001M9 9.00001L17 1M9 9.00001L1 1.00001M9 9.00001L17 17" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;
  
  const renderGenderedSizeSelector = ({ allFilters, values, id, name }) => {
    const genderFilters = allFilters.find(([filterName]) => filterName.includes("Gender"))?.[1] || [];
    const selectedFilters = getFiltersFromURL()?.find(([filterName]) => filterName === name)?.[1] || [];
    
    //Sort values into shoes sizes/apparel sizes and keep their order
    const numberEntries = values.filter(([size]) => !isNaN(parseInt(size)));
    const stringEntries = values.filter(([size]) => isNaN(parseInt(size)));
    numberEntries.sort(([a], [b]) => parseInt(a) - parseInt(b));
    const sortedSizes = [...numberEntries, ...stringEntries];

    const genderGroups = {
      mens: [],
      womens: [],
      kids: []
    };
    
    const kidsCategories = {
      'Big Kids (Ages 5+)': [],
      'Little Kids (Ages 1-5)': [],
      'Infant (Ages 0-1)': []
    };

    genderFilters.forEach(([gender]) => {
      const targetGroup = gender.includes('women') ? 'womens' : gender.includes('men') ? 'mens' : 'kids';
      if (targetGroup === 'kids') {
        const ageGroups = {
          'Big Kids (Ages 5+)': {
            sizes: ['11', '12', '13', '1', '2', '3', '4', '5'],
            hasSizes: false,
            html: []
          },
          'Little Kids (Ages 1-5)': {
            sizes: ['5', '6', '7', '8', '9', '10', '11'],
            hasSizes: false,
            html: []
          },
          'Infant (Ages 0-1)': {
            sizes: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
            hasSizes: false,
            html: []
          }
        };        
        
        sortedSizes.forEach((filterValue) => {
          const sizeValue = filterValue[0];
          for (const [groupName, groupData] of Object.entries(ageGroups)) {
            if (groupData.sizes.includes(sizeValue)) {
              groupData.hasSizes = true;
              
              const isChecked = selectedFilters.includes(sizeValue) ? 'checked' : '';
              const itemHTML = `
                  <div class="rounded flex items-center justify-center w-11 h-11 cursor-pointer relative border border-porcelain has-[:checked]:border-primaryBody hover:border-primaryBody">
                    <input 
                      data-action="apply-filter"
                      id="filter-${gender}-${sizeValue}-${id}" 
                      type="checkbox" 
                      class="!absolute !top-0 !left-0 !w-full !h-full z-10 !cursor-pointer !opacity-0 peer" 
                      value="${sizeValue}" 
                      data-gender="${gender}"
                      name="${name}"
                      data-label="${gender} ${name} ${sizeValue}"
                      ${isChecked}
                    >                   
                    <span 
                      class="absolute top-0 left-0 w-full h-full z-1 rounded transition duration-200 flex text-center items-center justify-center bg-pampas peer-checked:bg-primaryBody peer-checked:text-pampas peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-[#7aaad5] outline-offset-2">
                      <span class="p3 text-sm font-bold">
                          ${sizeValue}
                      </span>
                    </span>
                  </div>
                `;
                
                groupData.html.push(itemHTML);
              }
          }
        });
        for (const [groupName, groupData] of Object.entries(ageGroups)) {
          if (groupData.hasSizes) {
            kidsCategories[groupName] = groupData.html;
          }
        }
      } else {
        genderGroups[targetGroup].push(sortedSizes.map((filterValue) => {
          if (['1', '2', '3'].some(x => x === filterValue[0])) return;
          const isChecked = selectedFilters.includes(filterValue[0]) ? 'checked' : '';
          
          return `
            <div class="rounded flex items-center justify-center w-11 h-11 cursor-pointer relative border border-porcelain has-[:checked]:border-primaryBody hover:border-primaryBody">
              <input 
                data-action="apply-filter"
                id="filter-${gender}-${filterValue[0]}-${id}" 
                type="checkbox" 
                class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
                value="${filterValue[0]}" 
                name="${name}"
                data-gender="${gender}"
                data-label="${gender} ${name} ${filterValue[0]}"
                ${isChecked}
              >                   
              <span class="absolute top-0 left-0 w-full h-full z-1 rounded transition duration-200 flex text-center items-center justify-center bg-pampas peer-checked:bg-primaryBody peer-checked:text-pampas peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-[#7aaad5] outline-offset-2">
                <span class="p3 text-sm font-bold">
                  ${filterValue[0]}
                </span>
              </span>
            </div> 
          `;
        }).join(''));
      }
    });
    
    return `
      <style>
        [data-tab-womens="${id}"], [data-tab-mens="${id}"], [data-tab-kids="${id}"] {
          display: none;
        }
        body:has(#women-sizes-${id}:checked) [data-tab-womens="${id}"] {
          display: flex;
        }
        body:has(#men-sizes-${id}:checked) [data-tab-mens="${id}"] {
          display: flex;
        }
        body:has(#kid-sizes-${id}:checked) [data-tab-kids="${id}"] {
          display: flex;
        } 
      </style>
      <div class="flex w-full">
        ${genderGroups.womens.length ? `
          <label 
            for="women-sizes=${id}" 
            class="relative z-0 py-2 px-4 text-sm font-bold border-b-2 border-transparent  has-[input:checked]:border-primaryDark"
          >
            Women's
            <input 
              type="radio" 
              id="women-sizes-${id}" 
              name="gendered-sizes-${name}" 
              class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0" 
              checked="true"
              onchange="this.closest('[data-accordion-content]').style.height = '';"
            >
          </label>` : ''}
        ${genderGroups.mens.length ? `
          <label 
            for="men-sizes-${id}" 
            class="relative z-0 py-2 px-4 text-sm font-bold border-b-2 border-transparent  has-[input:checked]:border-primaryDark"
          >
            Men's
            <input 
              type="radio" 
              id="men-sizes-${id}" 
              name="gendered-sizes-${name}" 
              onchange="this.closest('[data-accordion-content]').style.height = '';"
              class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0" ${!genderGroups.womens.length ? 'checked="true"' : ''}
            >
          </label>
        ` : ''}
        ${Object.values(kidsCategories).some(arr => arr.length) || genderGroups.kids.length ? `
          <label 
            for="kid-sizes-${id}" 
            class="relative z-0 py-2 px-4 text-sm font-bold border-b-2 border-transparent  has-[input:checked]:border-primaryDark"
          >
            Kids
            <input 
              type="radio" 
              id="kid-sizes-${id}" 
              name="gendered-sizes-${name}" 
              onchange="this.closest('[data-accordion-content]').style.height = '';"
              class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0" ${!genderGroups.womens.length && !genderGroups.mens.length ? 'checked="true"' : ''}
            >
          </label>` : ''}
      </div> 
      ${genderGroups.womens.length ? `
        <div data-tab-womens="${id}" class="flex flex-wrap gap-2">
          ${genderGroups.womens.join('')}
        </div>
      ` : ''}
      ${genderGroups.mens.length ? `
        <div data-tab-mens="${id}" class="flex flex-wrap gap-2">
          ${genderGroups.mens.join('')}
        </div>
      ` : ''}
      ${Object.values(kidsCategories).some(arr => arr.length > 0) ? `
        <div data-tab-kids="${id}" class="flex flex-wrap gap-4">
          ${Object.entries(kidsCategories).map(([category, items]) => items.length ? `
            <div class="w-full">
              <h4 class="text-sm font-bold pb-4 block text-black-full">
                ${category}
              </h4>
              <div class="flex flex-wrap gap-2">
                ${items.join('')}
              </div>
            </div>` 
          : '').join('')}
        </div>
      ` : ''}
    `;
  };
  
  const renderSizeSelector = ({ values, id, name, hasKids }) => {
    const selectedFilters = getFiltersFromURL()?.find(([filterName]) => filterName === name)?.[1] || [];
    const numberEntries = values.filter(([size]) => !isNaN(parseInt(size)));
    const stringEntries = values.filter(([size]) => isNaN(parseInt(size)));
    numberEntries.sort(([a], [b]) => parseInt(a) - parseInt(b));
    const sortedSizes = [...numberEntries, ...stringEntries]; 
    if (hasKids) {
      const kidsCategories = {
        'Big Kids (Ages 5+)': {
          sizes: ['11', '12', '13', '1', '2', '3', '4', '5'],
          hasSizes: false,
          html: []
        },
        'Little Kids (Ages 1-5)': {
          sizes: ['5', '6', '7', '8', '9', '10', '11'],
          hasSizes: false,
          html: []
        },
        'Infant (Ages 0-1)': {
          sizes: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
          hasSizes: false,
          html: []
        }
      };
      
      
      
      sortedSizes.forEach((filterValue) => {
        const sizeValue = filterValue[0];
        for (const [groupName, groupData] of Object.entries(kidsCategories)) {
          if (groupData.sizes.includes(sizeValue)) {
            groupData.hasSizes = true;
            
            const isChecked = selectedFilters.includes(sizeValue) ? 'checked' : '';
            const itemHTML = `
              <div class="rounded flex items-center justify-center w-11 h-11 cursor-pointer relative border border-porcelain has-[:checked]:border-primaryBody hover:border-primaryBody">
                <input 
                  data-action="apply-filter"
                  id="filter-kids-${sizeValue}-${id}" 
                  type="checkbox" 
                  class="!absolute !top-0 !left-0 !w-full !h-full z-10 !cursor-pointer !opacity-0 peer" 
                  value="${sizeValue}" 
                  name="${name}"
                  data-label="kids ${name} ${sizeValue}"
                  ${isChecked}
                >                   
                <span 
                  class="absolute top-0 left-0 w-full h-full z-1 rounded transition duration-200 flex text-center items-center justify-center bg-pampas peer-checked:bg-primaryBody peer-checked:text-pampas peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-[#7aaad5] outline-offset-2">
                  <span class="p3 text-sm font-bold">
                      ${sizeValue}
                  </span>
                </span>
              </div>
            `;
            
            groupData.html.push(itemHTML);
          }
        }
      });
      
      if (Object.values(kidsCategories).some(group => group.hasSizes)) {
        return `
          <div class="flex flex-wrap gap-4">
            ${Object.entries(kidsCategories).map(([category, groupData]) => groupData.hasSizes ? `
              <div class="w-full">
                <h4 class="text-sm font-bold pb-4 block text-black-full">
                  ${category}
                </h4>
                <div class="flex flex-wrap gap-2">
                  ${groupData.html.join('')}
                </div>
              </div>` 
            : '').join('')}
          </div>
        `;
      }
    }
    
    // Default size selector if no kids grouping needed
    return sortedSizes?.map((filterValue) => {
      const isChecked = selectedFilters.includes(filterValue[0]) ? 'checked' : '';
      
      return `
        <div class="rounded flex items-center justify-center w-11 h-11 cursor-pointer relative border border-porcelain has-[:checked]:border-primaryBody hover:border-primaryBody">
          <input 
            data-action="apply-filter"
            id="filter-${filterValue[0]}-${id}" 
            type="checkbox" 
            class="!absolute !top-0 !left-0 !w-full !h-full z-10 !cursor-pointer !opacity-0 peer" 
            value="${filterValue[0]}" 
            name="${name}"
            data-label="${name} ${filterValue[0]}"
            ${isChecked}
          >                   
          <span 
            class="
              rounded
              absolute 
              top-0 
              left-0 
              w-full 
              h-full 
              z-1 
              transition 
              duration-200 
              flex 
              text-center 
              items-center 
              justify-center 
              bg-pampas
              peer-checked:bg-primaryBody
              peer-checked:text-pampas
              peer-focus-visible:outline 
              peer-focus-visible:outline-2 
              peer-focus-visible:outline-[#7aaad5] 
              outline-offset-2
            "
          >
            <span class="p3 text-sm font-bold">${filterValue[0]?.replace('|', '<br>').replace('Men', 'M').replace('Women', 'W')}</span>
          </span>
        </div>
      `;
    }).join('');
  }
  
  const renderTagSelector = ({ values, id, name, label }) => {
    const selectedFilters = getFiltersFromURL()?.find(([filterName]) => filterName === name)?.[1] || [];
    
    return values?.map((tag) => {
      const isChecked = selectedFilters.includes(tag.value) ? 'checked' : '';
      
      return `
        <div class="flex gap-2 items-center justify-start relative group/wrap  ${tag.swatch ? `transition-all duration-200 shadow-none hover:shadow-filter` : ''}">
          ${!tag.swatch ? `<div class="filter-checkbox-wrap">` : ''}
          <input 
            data-action="apply-filter"
            id="${tag.title}-${id}" 
            type="checkbox" 
            class="filter-checkbox peer" 
            value="${tag.value}" 
            name="${name}"
            data-label="${label} ${tag.title}"
            ${isChecked}
          >
        
          ${!tag.swatch ? `
            <div class="text-primaryBody flex items-center absolute top-0 left-0 w-full h-full z-1 transition duration-500 justify-center opacity-0 peer-checked:opacity-100">
              <span class="block w-3">${checkmarkIcon}</span>
            </div>
            </div>
          ` : ''}

          <label 
            for="${tag.title}-${id}" 
            class="
              p-0 
              cursor-pointer 
              flex 
              gap-[6px]
              text-primaryDark
              group-has-[input:checked]/wrap:border-primaryBody
              
              has-[.swatch]:text-chicago
              has-[.swatch]:bg-pampas
              has-[.swatch]:px-4
              has-[.swatch]:py-[15px]
              has-[.swatch]:w-full
              has-[.swatch]:items-center
              has-[.swatch]:gap-3
              has-[.swatch]:rounded
              has-[.swatch]/wrap:border
              has-[.swatch]/wrap:border-transparent
              peer-focus-visible:outline 
              peer-focus-visible:outline-2 
              peer-focus-visible:outline-[#7aaad5] 
              outline-offset-2
            "
          >
            ${tag.swatch ? `<div class="w-6 h-6 swatch">${tag.swatch}</div>` : ''}
            <span class="block leading-5 border-b border-transparent group-hover/wrap:!border-chicago">${tag.title} (${tag.count})</span>
          </label>
        </div>
    `}).join('')
  }
  
  const renderCategorySelector = ({ values, id, name }) => {
    const selectedFilters = getFiltersFromURL()?.find(([filterName]) => filterName === name)?.[1] || [];
    
    return values?.map((filterValue) => {
      const isChecked = selectedFilters.includes(filterValue[0]) ? 'checked' : '';
      
      return `
    <div class="flex gap-2 items-center justify-start mb-3 last:mb-0">
      <div class="filter-checkbox-wrap">
        <input 
          data-action="apply-filter"
          id="filter-${filterValue[0]}-${id}" 
          type="checkbox" 
          class="filter-checkbox peer" 
          value="${filterValue[0]}" 
          name="${name}"
          data-label="${JSON.stringify(filterValue[2]).replace(/[^A-Za-z0-9-\w\s]/g, '')}"
          ${isChecked}
        >
      </div>
      <label for="filter-${filterValue[0]}-${id}" class="p-0 cursor-pointer flex gap-[6px] ">
        <span class="block text-lg leading-5">
          ${JSON.stringify(filterValue[2]).replace(/[^A-Za-z0-9-\w\s]/g, '')} (${filterValue[1]})
        </span>
      </label>
    </div>
  `}).join('')
  }
  
  const renderStandardSelector = ({ values, id, name }) => {
    const selectedFilters = getFiltersFromURL()?.find(([filterName]) => filterName === name)?.[1] || [];
    
    return values?.map((filterValue) => {
      const isChecked = selectedFilters.includes(filterValue[0]) ? 'checked' : '';
      
      return `
        <label for="filter-${filterValue[0]}-${id}" class="flex flex-col gap-2">
          <div class="flex gap-2 items-center justify-start">
            <div class="filter-checkbox-wrap group">
              <input 
                data-action="apply-filter"
                id="filter-${filterValue[0]}-${id}" 
                type="checkbox" 
                class="filter-checkbox peer" 
                value="${filterValue[0]}" 
                name="${name}"
                data-label="${filterValue[0]}"
                ${isChecked}
              >
              <div class="
                text-primaryBody
                flex
                items-center
                absolute
                top-0
                left-0
                w-full
                h-full
                z-1
                transition
                duration-500
                justify-center
                peer-focus-visible:outline 
                peer-focus-visible:outline-2 
                peer-focus-visible:outline-[#7aaad5]"
              >
                <span class="block w-3 opacity-0 group-has-[input:checked]:opacity-100 transition">${checkmarkIcon}</span>
              </div>
            </div>
            <span class="p-0 cursor-pointer flex gap-[6px] ">
              <span class="block text-lg leading-5 font-bold">${filterValue[0]} (${filterValue[1]})</span>
            </span>
          </div>
          ${window.filterLabels?.[filterValue[0]] ? `
            <span class="text-chicago leading-5 ml-[30px] pr-8">
              ${window.filterLabels[filterValue[0]]}
            </span>
            ` 
            : ''}
        </label>
    `}).join('')
  }
  
  const renderTypeSelector = ({ values, id, name }) => {
    const selectedFilters = getFiltersFromURL()?.find(([filterName]) => filterName === name)?.[1] || [];
    
    return values?.map((filterValue) => {
      const isChecked = selectedFilters.includes(filterValue[0]) ? 'checked' : '';
      
      return `
        <div class="flex gap-2 items-center justify-start relative w-full h-full group/wrap transition-all duration-200 shadow-none hover:shadow-filter">
          <input 
            data-action="apply-filter"
            id="filter-${filterValue[0]}-${id}" 
            type="checkbox" 
            class="!absolute !top-0 !left-0 !w-full !h-full z-10 !cursor-pointer !opacity-0 peer" 
            value="${filterValue[0]}" 
            name="${name}"
            data-swatch-name="${toHandle(filterValue[0])}"
            data-label="${JSON.stringify(filterValue[0])?.replace(/[^A-Za-z0-9-\w\s]/g, '')}"
            ${isChecked}
          >        
              
          <label 
            for="filter-${filterValue[0]}-${id}" 
            class="
              cursor-pointer 
              flex 
              flex-col
              items-center
              justify-center
              gap-[6px]
              bg-pampas
              p-4
              h-full
              w-full
              rounded
              border
              border-transparent
              text-chicago
              group-has-[input:checked]/wrap:border-primaryBody
              group-has-[input:checked]/wrap:text-primaryBody
              group-has-[input:checked]/wrap:bg-white
              peer-focus-visible:outline 
              peer-focus-visible:outline-2 
              peer-focus-visible:outline-[#7aaad5] 
              outline-offset-2
            "
          >
            <img 
              class="block object-cover object-center w-[61px] h-10 mix-blend-multiply"
              width="150"
              height="100"
              alt="/cdn/shop/files/swatch-${toHandle(filterValue[0])}.png"
              src="/cdn/shop/files/swatch-${toHandle(filterValue[0])}.png" 
            />
            <span class="inline-block leading-5 text-center border-b border-transparent group-hover/wrap:!border-chicago">
              ${filterValue[0]} (${filterValue[1]})
            </span>
          </label>
        </div>
      `}).join('')
  }
  
  const renderAccordionFilters = ({ label, id, renderSelector, index }) => `
    <div style="order: ${index}">
    <button 
      data-label="${label}"
      data-independent
      data-accordion-toggle="${label}-${id}" 
      class="${(label.toLowerCase().includes('fit') || label.toLowerCase().includes('prime')) ? `open`: ''} text-primaryDark flex text-2xl uppercase font-heading tracking-[1.2px] items-center justify-between w-full rounded-none border-t border-[#e2e1dd] py-3 whitespace-nowrap"
    >
    ${label}
    <div aria-hidden="true" class="w-5 h-5 relative">
    <span class="absolute top-1/2 transform translate-y-1/2 left-0 w-full block border border-current"></span>
    <span class="absolute block w-full h-0.5 top-1/2 transform translate-y-1/2">
      <span data-rotate-active style="${(label.toLowerCase().includes('fit') || label.toLowerCase().includes('prime')) ? '' : 'transform: rotate(0deg)'}" class="transform rotate-90 transition duration-200 left-0 w-full block border border-current"></span>
    </span>
    </div>
    </button>
    <div 
    data-label="${label}"
    data-accordion-content="${label}-${id}" 
    class="transition-all duration-500 overflow-y-clip overflow-x-visible"
    ${(label.toLowerCase().includes('fit') || label.toLowerCase().includes('prime')) ? 'style="height: 0;"' : ''}
    >
    <div 
    class="
      pb-4 
      ${!label.toLowerCase().trim().includes('size') 
      && !label.toLowerCase().trim().includes('color') 
      && !label.toLowerCase().trim().includes('type') && !label.toLowerCase().trim().includes('style')
      ? 'flex flex-col gap-3' 
      : ''
    }
      ${label.toLowerCase().trim().includes('size') ? 'flex gap-3 items-center justify-start flex-wrap' : ''}
      ${(label.toLowerCase().trim().includes('color') || label.toLowerCase().trim().includes('type') || label.toLowerCase().trim().includes('style')) ? 'grid grid-cols-2 gap-2 items-center justify-start flex-wrap pt-1' : ''}"
    >
    ${renderSelector()}
    </div>
    </div>
    </div>
  `;

  const renderRemoveSpecificFilterButton = ({ value, label, name }) => `
    <button 
      data-filter-value="${value}"
      data-action="remove-filter"
      class="whitespace-nowrap flex p-2 xl:p-2.5 items-center justify-center gap-[6px] relative h-8 text-sm bg-white rounded-[50px]"
    >
      ${label.replace(`Isp-tag-`, ``).replace(`color-`, ``).replace('gender-', '')} <strong class="capitalize">${value.replace(`color-`, ``).replace('gender-', '').replace('multi', 'Pattern')}</strong>
      <span class="w-[14px] h-[14px]">${xIcon}</span>
    </button>
  `;

  const getFiltersFromURL = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const filters = [];
    for (const key of searchParams.keys()) {
      const values = searchParams.getAll(key);
      filters.push([key, values]);
    }
    return filters;
  };
  
  const hasGenderAndSizeFilters = (data) => {
    let hasGender = false;
    let hasSize = false;
    
    for (const filter of data) {
      const [, values, label] = filter;
      if (label === "Gender") {
        if (values.length > 1) hasGender = true;
      }
      if (label.toLowerCase().includes("size")) hasSize = true;
      
      if (hasGender && hasSize) return true;
    }
    
    return false;
  }

  const hasKidsFilter = (data) => {
    const genderTag = data.find(item => item[0] === "Isp-tag-Gender");
    if (genderTag && Array.isArray(genderTag[1])) {
      return genderTag[1].some(subItem => subItem[0] === "gender-kids");
    }
    
    return false;
  };
